import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    gsap.from(element.querySelectorAll(".product-1 .grape-1, .product-1 .grape-2, .product-1 .grape-3"), {
        scrollTrigger: {
            trigger: element,
            start: "top bottom-=10%",
            // toggleActions: "play none play none",
        },
        x: (i) => i === 2 ? -60 : 60,
        y: 80,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.2
    });

    gsap.from(element.querySelectorAll(".product-2 .grape-1, .product-2 .grape-2, .product-2 .grape-3,  .product-2 .grape-4"), {
        scrollTrigger: {
            trigger: element,
            start: "top bottom-=10%",
            // toggleActions: "play none play none",
        },
        x: (i) => i === 3 ? -60 : 60,
        y: (i) => i === 0 ? -80 : 80,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.2
    });
    gsap.from(element.querySelectorAll(".pill-icon, .glass-icon"), {
        scrollTrigger: {
            trigger: element,
            start: "top bottom-=10%"
        },
        // x: (i) => i === 3 ? -60 : 60,
        // y: (i) => i === 0 ? -80 : 80,
        scale: 0,
        opacity: 0,
        duration: 2,
        ease: "power4.out"
    });
};